export const ITEMS_PER_ROWS_DEFAULT = {
  s: 1,
  m: 2,
  l: 3,
  xl: 4,
};
